import { P00039DataRxTxIndex } from '../../P00039Sync';
import { IProduct } from '../../../IProduct';
import { Pool } from '../../../../../../apis/pool.api';

export function P00032InstallationReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.Sense_Controle,
    'snCResetUsine',
    1,
    null,
    productClass,
  );
}
